import {Box, Heading, type SxProp} from '@primer/react'
import type {StyledHeadingProps} from './SectionHeader'

type ReadonlySectionHeaderProps = {
  title: string
  'data-testid'?: string
  headingProps?: StyledHeadingProps
} & SxProp

export function ReadonlySectionHeader({
  title,
  headingProps: {as: Component = 'h3', ...headingProps} = {},
  ...props
}: ReadonlySectionHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        pl: 2,
        ...props.sx,
      }}
    >
      <Heading as={Component} sx={{fontSize: 1, ...headingProps}}>
        {title}
      </Heading>
    </Box>
  )
}

try{ ReadonlySectionHeader.displayName ||= 'ReadonlySectionHeader' } catch {}